
type HeaderMaps = {
    puMap: Map<number, string>;
    trMap: Map<number, string>;
};

export class VehicleTemplateConstants {

    // Headers for Vehicle Template PU and TR for different versions of the template    
    public static readonly VEHICLE_TEMPLATE_HEADERS: Record<string, HeaderMaps> = {
        "1.0": {
            puMap: new Map<number, string>([
                    [0, 'Year'],
                    [1, 'Make'],
                    [2, 'Model'],
                    [3, 'VIN'],
                    [4, 'Is this the correct garaging address?'],
                    [5, 'Vehicle Weight Class'],
                    [6, 'Vehicle Body Type'],
                    [7, 'Secondary Classification'],
                    [8, 'Local - Annual miles <= 50 miles (in %)'],
                    [9, 'Intermediate - 50 miles > Annual miles <= 200 (in %)'],
                    [10, 'Comprehensive Deductible'],
                    [11, ''],
                    [12, 'Collision Deductible'],
                    [13, ''],
                    [14, 'Stated Amount per Unit (Including custom parts & equipment)'],
                    [15, 'Are there custom parts and equipment on this unit?'],
                    [16, ''],
                    [17, ''],
                    [18, 'Does this unit have an additional insured or loss payee?']
            ]),
            trMap: new Map<number, string>([
                    [0, 'Year'],
                    [1, 'Make'],
                    [2, 'Model'],
                    [3, 'VIN'],
                    [4, 'Is this the correct garaging address?'],
                    [5, 'Trailer Weight Class'],
                    [6, 'Trailer Body Type'],
                    [7, 'Secondary Classification'],
                    [8, 'Local - Annual miles <= 50 miles (in %)'],
                    [9, 'Intermediate - 50 miles > Annual miles <= 200 (in %)'],
                    [10, 'Comprehensive Deductible'],
                    [11, ''],
                    [12, 'Collision Deductible'],
                    [13, ''],
                    [14, 'Stated Amount per Unit (Including custom parts & equipment)'],
                    [15, 'Are there custom parts and equipment on this unit?'],
                    [16, ''],
                    [17, ''],
                    [18, 'Does this unit have an additional insured or loss payee?']
                ])                
        },
        "1.1": {
            puMap: new Map<number, string>(
                [
                    [0,  'Year'],
                    [1,  'Make'],
                    [2,  'Model'],
                    [3,  'VIN'],
                    [4,  'Is this the correct garaging address?'],
                    [5,  'Vehicle Weight Class'],
                    [6,  'Vehicle Body Type'],
                    [7,  'Secondary Classification'],
                    [8,  'Local - Annual miles <= 50 miles (in %)'],
                    [9,  'Intermediate - 50 miles > Annual miles <= 200 (in %)'],
                    [10, 'Long Distance - Annual miles > 200 (in %)'],
                    [11, 'Farthest Zone Traveled'],
                    [12, 'Comprehensive Deductible'],
                    [13, ''],
                    [14, 'Collision Deductible'],
                    [15, ''],
                    [16, 'Stated Amount per Unit (Including custom parts & equipment)'],
                    [17, 'Are there custom parts and equipment on this unit?'],
                    [18, ''],
                    [19, ''],
                    [20, 'Does this unit have an additional insured or loss payee?']
                ]),
            trMap: new Map<number, string>(
                [
                    [0,  'Year'],
                    [1,  'Make'],
                    [2,  'Model'],
                    [3,  'VIN'],
                    [4,  'Is this the correct garaging address?'],
                    [5,  'Trailer Weight Class'],
                    [6,  'Trailer Body Type'],
                    [7,  'Secondary Classification'],
                    [8,  'Local - Annual miles <= 50 miles (in %)'],
                    [9,  'Intermediate - 50 miles > Annual miles <= 200 (in %)'],
                    [10, 'Long Distance - Annual miles > 200 (in %)'],
                    [11, 'Farthest Zone Traveled'],
                    [12, 'Comprehensive Deductible'],
                    [13, ''],
                    [14, 'Collision Deductible'],
                    [15, ''],
                    [16, 'Stated Amount per Unit (Including custom parts & equipment)'],
                    [17, 'Are there custom parts and equipment on this unit?'],
                    [18, ''],
                    [19, ''],
                    [20, 'Does this unit have an additional insured or loss payee?']
                ])            
        }
    }

    // to mapping the values index based on the version of the template
    
    public static readonly VEHICLE_TEMPLATE_VALUE_MAP = {
        "1.0": {
            PowerUnit: {
                Year: "Please use Trailer tab to upload Trailer details",
                Make: "__EMPTY",
                Model: "__EMPTY_1",
                VIN: "__EMPTY_2",
                IsCorrectGaraging: "__EMPTY_3",
                VehicleSize: "__EMPTY_4",
                BodyType: "__EMPTY_5",
                SecondaryClass: "__EMPTY_6",
                TotalMilesUpto50: "__EMPTY_7",
                TotalMilesUpto200: "__EMPTY_8",
                CompOTCCoverage: "__EMPTY_9",
                Comp: "__EMPTY_10",
                CollCoverage: "__EMPTY_11",
                Coll: "__EMPTY_12",
                StatedAmount: "__EMPTY_13",
                CustomParts: "__EMPTY_14",
                CustomAmount: "__EMPTY_15",
                CustomDesc: "__EMPTY_16",
                AddInsuredOrLossPayee: "__EMPTY_17"
            },
            Trailer: {
                Year: "Year",
                Make: "Make",
                Model: "Model",
                VIN: "VIN",
                IsCorrectGaraging: "Is this the correct garaging address?",
                TrailerSize: "Trailer Weight Class",
                TrailerBodyType: "Trailer Body Type",
                SecondaryClass: "Secondary Classification",
                TotalMilesUpto50: "Local - Annual miles <= 50 miles (in %)",
                TotalMilesUpto200: "Intermediate - 50 miles > Annual miles <= 200 (in %)",
                CompOTCCoverage: "Comprehensive Deductible",
                Comp: "__EMPTY",
                CollCoverage: "Collision Deductible",
                Coll: "__EMPTY_1",
                StatedAmount: "Stated Amount per Unit (Including custom parts & equipment)",
                CustomParts: "Are there custom parts and equipment on this unit?",
                CustomAmount: "__EMPTY_2",
                CustomDesc: "__EMPTY_3",
                AddInsuredOrLossPayee: "Does this unit have an additional insured or loss payee?"
            }
        },
        "1.1": {
            PowerUnit: {
                Year: "Please use Trailer tab to upload Trailer details",
                Make: "__EMPTY",
                Model: "__EMPTY_1",
                VIN: "__EMPTY_2",
                IsCorrectGaraging: "__EMPTY_3",
                VehicleSize: "__EMPTY_4",
                BodyType: "__EMPTY_5",
                SecondaryClass: "__EMPTY_6",
                TotalMilesUpto50: "__EMPTY_7",
                TotalMilesUpto200: "__EMPTY_8",
                FarthestApplicableZonePercent: "__EMPTY_9",
                FarthestToZone: "__EMPTY_10",
                CompOTCCoverage: "__EMPTY_11",
                Comp: "__EMPTY_12",
                CollCoverage: "__EMPTY_13",
                Coll: "__EMPTY_14",
                StatedAmount: "__EMPTY_15",
                CustomParts: "__EMPTY_16",
                CustomAmount: "__EMPTY_17",
                CustomDesc: "__EMPTY_18",
                AddInsuredOrLossPayee: "__EMPTY_19"
            },
            Trailer: {
                Year: "Year",
                Make: "Make",
                Model: "Model",
                VIN: "VIN",
                IsCorrectGaraging: "Is this the correct garaging address?",
                TrailerSize: "Trailer Weight Class",
                TrailerBodyType: "Trailer Body Type",
                SecondaryClass: "Secondary Classification",
                TotalMilesUpto50: "Local - Annual miles <= 50 miles (in %)",
                TotalMilesUpto200: "Intermediate - 50 miles > Annual miles <= 200 (in %)",
                FarthestApplicableZonePercent: "Long Distance - Annual miles > 200 (in %)",
                FarthestToZone: "Farthest Zone Traveled",
                CompOTCCoverage: "Comprehensive Deductible",
                Comp: "__EMPTY",
                CollCoverage: "Collision Deductible",
                Coll: "__EMPTY_1",
                StatedAmount: "Stated Amount per Unit (Including custom parts & equipment)",
                CustomParts: "Are there custom parts and equipment on this unit?",
                CustomAmount: "__EMPTY_2",
                CustomDesc: "__EMPTY_3",
                AddInsuredOrLossPayee: "Does this unit have an additional insured or loss payee?"
            }
        },
    }

}